enum BeeswaxCatchupBehavior {
  Immediate = 'immediate',
  Even = 'even',
  Smooth = 'smooth',
}
export default BeeswaxCatchupBehavior;
